<nb-card [nbSpinner]="sharedService.load" class="nb-card-container">
  <nb-card-header>REDEEM INFORMATION</nb-card-header>
  <nb-card-body>
    <div class="total-top-panel">
      <button nbButton (click)="onScanNewGC()" status="info">
        <nb-icon icon="plus-outline"></nb-icon>Add new gift card
      </button>
      Total redeem amt:
      <strong>${{ redeemAmt || 0 | AmountPipe }}</strong>
    </div>
    <div class="redeem-list-container">
      <nb-card
        class="card-element"
        *ngFor="let data of tmpRedeems"
        [class.card-element--revoked]="!!data?.giftCard?.deletedAt"
      >
        <nb-card-header
          ><nb-icon icon="credit-card-outline" status="info"></nb-icon> Gift Card {{ data?.giftCard?.code }}
          <span *ngIf="data?.giftCard?.deletedAt" class="blink tag-color tag-color--danger">Revoked</span>
          <button nbButton outline status="danger" (click)="onRemoveCard(data?.giftCard?.code)">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </nb-card-header>
        <nb-card-body class="card-info">
          <div *ngIf="!!data" class="container">
            <div class="row">
              <div class="col-12 col-sm-6">
                <!--                <div class="row-info"><label>Code:</label>{{ data?.giftCard?.code }}</div>-->
                <div class="row-info">
                  <label>Customer:</label
                  >{{ (data?.giftCard?.customerFirstName || '') + ' ' + (data?.giftCard?.customerLastName || '') }}
                </div>
                <div class="row-info">
                  <label>Phone number:</label>{{ data?.giftCard?.customerPhoneNumber | PhoneNumberPipe }}
                </div>
                <div class="row-info">
                  <label>Init balance:</label>${{ data?.giftCard?.initBalance || 0 | AmountPipe }}
                </div>
                <div class="row-info">
                  <label>Available balance:</label>
                  <span *ngIf="data?.giftCard?.availableRedeemBalance" class="tag-color tag-color--info"
                    ><strong>${{ data?.giftCard?.availableRedeemBalance || 0 | AmountPipe }}</strong></span
                  >
                  <span *ngIf="!data?.giftCard?.availableRedeemBalance" class="tag-color tag-color--danger"
                    ><strong>${{ data?.giftCard?.availableRedeemBalance || 0 | AmountPipe }}</strong></span
                  >
                </div>
                <div class="row-info">
                  <label>Redeem amt:</label>
                  <input
                    *ngIf="!data?.giftCard?.deletedAt"
                    class="input-amt"
                    nbInput
                    type="text"
                    appCurrencyInput
                    [(ngModel)]="data.amt"
                    (change)="onRedeemAmtChange()"
                  />
                  <span *ngIf="!!data?.giftCard?.deletedAt" class="tag-color tag-color--info"
                    ><strong>${{ data.amt || 0 | AmountPipe }}</strong></span
                  >
                </div>
              </div>
              <div class="col-12 col-sm-6">
                <div class="row-info">
                  <label>Sold by:</label>
                  <app-avatar [user]="data.giftCard.soldByEmployee" size="medium"></app-avatar>
                  <!--                  {{ data?.giftCard?.soldByEmployee | PersonNamePipe }}-->
                </div>
                <div class="row-info">
                  <label>Sold at:</label>{{ data?.giftCard?.soldAt | date: 'yyyy-MM-dd HH:mm:ss' }}
                </div>
                <div class="row-info">
                  <label>Expired at:</label>{{ data?.giftCard?.expiredAt | date: 'yyyy-MM-dd' }}
                  <span *ngIf="data?.giftCard?.isExpired" class="blink tag-color tag-color--warning">Expired</span>
                </div>
                <div class="row-info"><label>Note:</label>{{ data?.giftCard?.note }}</div>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button *ngIf="mode === EMode.NEW" nbButton (click)="onOk()" status="success">
      <nb-icon icon="checkmark-outline"></nb-icon>OK
    </button>
    <button *ngIf="mode === EMode.UPDATE" nbButton (click)="onOk()" status="success">
      <nb-icon icon="save-outline"></nb-icon>SAVE
    </button>
    <button class="right-button" nbButton (click)="onCancel()"><nb-icon icon="close-outline"></nb-icon>CANCEL</button>
  </nb-card-footer>
</nb-card>
